<template>
  <div class="modal overflow-x-hidden overflow-y-scroll  h-full mx-auto bg-white text-main-text" @click.self="dismiss">
    <div class="modal-box bg-white rounded-lg relative container mx-auto lg:px-32 md:px-16 lg:py-10 xl:py-10" :class="[isForOneSelect ? '' : 'my-16 ']">
       <font-awesome-icon :icon="['fal', 'times']" class="absolute text-brand-grey-light pin-t pin-r mr-8 -mt-8 lg:mt-8 xl:mt-8 cursor-pointer text-2xl z-50" @click="dismiss"></font-awesome-icon>
      <div class="modal-heading">
        <h2 v-if="isForOneSelect" class="text-brand-darker font-extrabold text-heading text-2xl text-left">Выберите город</h2>
        <h2 v-else class="text-brand-darker font-extrabold text-heading text-lg lg:text-2xl xl:text-2xl text-left">Выберите ваш город</h2>
      </div>
      <div class="modal-search my-8 w-full lg:w-1/3 xl:w-1/3">

        <input type="text" @input="debounce_value($event.target.value)" placeholder="Поиск" class="border border-menuOrder-dark-blue w-full rounded-lg p-2 px-4 pl-12 text-main-text">
      </div>
      <div class="sorry" v-if="!temp_arr.length">
        <p class="font-extrabold">Упс! В этом городе Мозгобойни еще нет. </p>
<p class="font-extrabold">Хотите, чтобы она появилась? <a target="_blank" href="https://partners.mozgo.com/" class="text-brand-light font-extrabold">Можете стать нашим партнером :)</a></p>
      </div>
      <div class="modal-content"  :class="[ temp_arr.length <= 5 ?  'city-unlisting' : 'city-listing']">
        <Country v-for="country in countries" :key="country.id"  :country="country" @selected_city="city_select" :search="search_pannel"></Country>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import base from '@/clients/base';
import player from '@/clients/player';
import Country from './helpers/country.vue';
import modal from '../../mixins/modals.js';
import { mapActions, mapGetters } from 'vuex';


export default {
  name: 'CityList',
  components: { Country },
  mixins: [modal],
  props: {
    isForOneSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search_pannel: '',
      selected_city: '',
      social_link: '',
      temp_arr: [1, 2, 3, 4, 5, 6],
      countries: {},
    };
  },
  computed: {
    city() {
      return this.$store.getters.cityProps.city;
    },
  },
  methods: {
    ...mapActions(['selectCityInfo', 'setApplicationIsFetched', 'refreshUser']),
    debounce_value: _.debounce(function (e) {
      this.search_pannel = e.trim();
    }, 1000),
    city_select(e) {
      base.get(`/locations/cities/${e.city_id}`)
        .then((response) => {
          this.selected_city = response.data.city;
          this.social_link = response.data.social_network_link;
          if (this.isForOneSelect) {
            this.$emit('selected', e.city_id, this.selected_city);
          } else {
            this.selectCityInfo(response.data);
            this.setApplicationIsFetched(false);
            this.$emit('add_social_link');
          }
          this.$router.go('/');
        });
    },

  },
  created() {
    base
      .get('/locations')
      .then((response) => {
        this.countries = response.data;
        const result_arr = [];
        for (const country in this.countries) {
          this.countries[country].forEach((item) => {
            if (item.name.toLowerCase().indexOf(this.city.toLowerCase()) > -1) {
              result_arr.push(item);
            }
          });
        }
        if (!result_arr.length) this.$emit('city_out');
      });
  },
  watch: {
    search_pannel() {
      this.temp_arr = [];
      for (const country in this.countries) {
        this.countries[country].forEach((item) => {
          if (((item && item.name).toLowerCase()).indexOf((this.search_pannel).toLowerCase()) > -1) this.temp_arr.push((item));
        });
      }
    },
  },


};
</script>

<style lang="less" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 100;
}
.modal-content {
    min-width: 780px !important;
}
.modal-box {
  // width: fit-content;
}
input[type="text"] {
  // box-shadow: 0 15px 35px rgba(0, 0, 0, 0.07), 0 5px 15px rgba(0, 0, 0, 0.07);
  font-family:  'Montserrat', sans-serif;
  font-weight: 800;
  background: url('../../assets/SVG/search.svg') no-repeat 5% 45%;
}
input:active, input:focus {
  outline: none;
}
.city-listing {
  columns: 3;
}
.city-unlisting {
  columns: 1;
}
.sorry {

}
.sorry p {
font-family: "Montserrat";
}
h2 {
  font-family: 'Montserrat', sans-serif;
}

@media (min-width: 320px) and (max-width: 480px) {
  .city-listing {
    columns: 1;
  }
  .modal-box {
    padding-left: 25px;
    padding-right: 25px;

  }
  .modal {
    background-color: transparent;
  }
  .sorry {
    font-size: 12px;
    a {
      display: block;
      margin-top: 15px;
    }
  }
}
</style>
